import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LoadingService } from '../../shared/services/loading.service';
import { EditDialogComponent } from '../editDialog/editDialogComponent';
import { EditDialogInstance } from '../editDialog/editDialogService';
import { EventSubscription, EventSubscriptionInput } from '../../shared/entities/events/event';
import { EventSubscriptionService } from '../../shared/services/eventSubscription/eventSubscriptionService';
import { EditSelectable } from '../../formControls/edit-select-form-control.component';

@Component({
  selector: 'app-subscription-dialog',
  templateUrl: './subscription-dialog.component.html',
  styleUrls: ['./subscription-dialog.component.scss']
})
export class SubscriptionSecretDialogComponent
  implements EditDialogInstance {

  subscriptionSecretForm: FormGroup;
  subscription: EventSubscription;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public loadingService: LoadingService,
    public eventSubscriptionService: EventSubscriptionService
  ) {
    if (this.config.data) {
      this.subscription = this.config.data;
    }

    this.subscriptionSecretForm = new FormGroup({});
    this.subscriptionSecretForm.addControl('secret', new FormControl(undefined, Validators.required));

  }

  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    this.loadingService.setLoading(true);
    let eventSubscriptionId = this.subscription?.id;
    let secret = this.subscriptionSecretForm.value?.secret;
    console.log('Setting secret for event subscription:', eventSubscriptionId, 'with secret:', secret);
    this.eventSubscriptionService.setSecret(eventSubscriptionId, secret, (result: any) => {
      this.loadingService.setLoading(false);
      this.ref.close(eventSubscriptionId);
    });
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.subscriptionSecretForm;
  }

}
